module.exports = __webpack_public_path__ + "img/2.e084fc08.jpg";